import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import {Action} from '../../../system/buttons';
import '../../../App.css';
import {
  BACKGROUND_TYPE_TO_URL,
  ImagePicker,
  JumpScareBackgroundType,
  JumpScareCounterWidgetProps,
  JumpScareSecondaryImageType,
  SECONDARY_IMAGE_TYPE_TO_URL,
} from '@pulsoid-private/widgets-lib';
import {NewFontManager} from '../../../system/NewFontManager/NewFontManager';

type Configuration = Partial<JumpScareCounterWidgetProps['configuration']> & {
  version: number;
};

export const JumpScareCounterEditNew = (props: any) => {
  const [configuration, setConfiguration] = React.useState<Configuration>(
    props.configuration?.version === 2
      ? props.configuration
      : {
          version: 2,
          bpmText: {
            font: props.configuration?.font,
            color: props.configuration?.color,
          },
          triggerHeartRate: props.configuration?.triggerHeartRate,
          backgroundColor: '#000000',
        }
  );

  const updateConfiguration = (configPart) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  React.useEffect(() => {
    props.onUpdate({...props.configuration, version: 2});
  }, []);

  return (
    <>
      <h4>Images Configuration</h4>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Background
        </Form.Label>
        <Col sm="6">
          <ImagePicker
            preset={Object.values(JumpScareBackgroundType)}
            selectedItem={configuration?.backgroundType || null}
            renderItem={(item) => (
              <img
                src={BACKGROUND_TYPE_TO_URL[item]}
                alt={item}
                key={item}
                style={{width: 40, height: 50, position: 'relative', right: 2}}
              />
            )}
            onSelect={(backgroundType) => updateConfiguration({backgroundType})}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          {/* Widget Icon settings */}
        </Form.Label>

        <Form.Group as={Col} sm="3">
          <Form.Label htmlFor="backgroundColor">Background color</Form.Label>
          <ColorPicker
            color={configuration?.backgroundColor}
            onChangeComplete={(backgroundColor) =>
              updateConfiguration({backgroundColor})
            }
          />
        </Form.Group>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Image
        </Form.Label>
        <Col sm="6">
          <ImagePicker
            preset={Object.values(JumpScareSecondaryImageType)}
            selectedItem={configuration?.secondaryImageType || null}
            renderItem={(item) => (
              <img
                src={SECONDARY_IMAGE_TYPE_TO_URL[item]?.picker}
                alt={item}
                key={item}
                style={{height: 40, margin: '0 auto', display: 'block'}}
              />
            )}
            onSelect={(secondaryImageType) =>
              updateConfiguration({secondaryImageType})
            }
          />
        </Col>
      </Form.Group>

      <h4>Text Configuration</h4>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Color
        </Form.Label>
        <Col sm="3">
          <ColorPicker
            color={configuration?.bpmText?.color}
            onChangeComplete={(color) =>
              updateConfiguration({bpmText: {...configuration?.bpmText, color}})
            }
          />
        </Col>
      </Form.Group>

      <NewFontManager
        as={Row}
        onChange={(font) =>
          updateConfiguration({
            bpmText: {...configuration.bpmText, font},
          })
        }
        font={configuration?.bpmText?.font!}
        withUpload
      />

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Text
        </Form.Label>
        <Col sm="3">
          <Form.Control
            value={configuration.description}
            onChange={(e) => {
              updateConfiguration({description: e.target.value});
            }}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Trigger heart rate
        </Form.Label>
        <Col sm="3">
          <Form.Control
            value={configuration.triggerHeartRate}
            onChange={(e) => {
              let triggerHeartRate = parseInt(e.target.value);
              if (!isNaN(triggerHeartRate)) {
                updateConfiguration({triggerHeartRate});
              }
            }}
          />
        </Col>
      </Form.Group>

      <Action onClick={() => props.onSave(configuration)}>Save settings</Action>
    </>
  );
};
